<div class="mapa-brasil">
    <app-painel-lateral [tituloPainel]="tituloMapa" [descricaoPainel]="'Visão geral e distribuição geográfica de inscrições e cadastros de médicos.'" [iconePainel]="'pi pi-map'" [filtrosTemplate]="filtros" [conteudoTemplate]="conteudo">
        <ng-template #filtros>
            <div class="mapa-card">
                <app-mapa-uf class="mapa-uf" [ufSelecionada]="ufSelecionada" (estadoSelecionado)="onEstadoSelecionado($event)"></app-mapa-uf>
            </div>

            <label class="mapa-filtro">
                <span class="mapa-filtro-label">UF do estado</span>
                <app-estado-select [uf]="ufSelecionada ?? 'BR'" [ufsPermitidas]="ufsPermitidas" (ufChange)="onUfSelecionadaChange($event)"></app-estado-select>
            </label>
        </ng-template>

        <ng-template #conteudo>
            <div class="mapa-indicadores">
                <div class="indicadores-grid">
                    <div class="card-entrada card-entrada-1 indicador-card" [ngClass]="resumoMapa.classeGrupo">
                        <app-card-content [border]="false" [title]="resumoMapa.titulo" [subtitle]="resumoMapa.descricao" icon="pi pi-chart-bar">
                            <div class="estatistica-total-bloco">
                                @if (resumoMapa.total !== null) {
                                    <span class="estatistica-total-valor">{{ resumoMapa.total | number }}</span>
                                    <span class="estatistica-total-label">movimentos</span>
                                } @else {
                                    <p-skeleton width="92px" height="30px" />
                                }
                            </div>
                        </app-card-content>
                    </div>

                    @for (item of obterItensVisiveis(resumoMapa.itens); track item.label) {
                        <div class="card-entrada card-entrada-1 indicador-card" [ngClass]="resumoMapa.classeGrupo">
                            <app-card-content [border]="false" [title]="item.label" [subtitle]="resumoMapa.grupo" icon="pi pi-user">
                                <div class="estatistica-total-bloco">
                                    @if (item.valor !== null) {
                                        <span class="estatistica-total-valor">{{ item.valor | number }}</span>
                                        <span class="estatistica-total-label">{{ item.unidade ?? 'registros' }}</span>
                                    } @else {
                                        <p-skeleton width="92px" height="30px" />
                                    }
                                </div>
                            </app-card-content>
                        </div>
                    }
                </div>
            </div>
        </ng-template>
    </app-painel-lateral>
</div>
